import * as Yup from "yup";

export function initialValues(billingData) {
  return {
    billingNumber: billingData?.billingNumber || "",
    description: billingData?.description || "",
    billingtotal: billingData?.billingtotal || "",
    billingpartner: billingData?.billingpartner || "",
    status: billingData?.status || "pending",
    file1: null,
    file2: null,
    userId: "", // Para la selección del usuario
    senderRole: "", // Para guardar el rol del usuario seleccionado
  };
}

export function validationSchema() {
  return Yup.object({
    billingNumber: Yup.string().required("Requerido"),
    description: Yup.string().required("Requerido"),
    billingtotal: Yup.number().required("Requerido"),
    billingpartner: Yup.number().required("Requerido"),
    status: Yup.string()
      .oneOf(["pending", "paid", "cancelled"])
      .required("Requerido"),
  });
}
